<template>
  <div class="progression-nav-card"
       :class="{ 'progression-nav-card__disabled': disabled }">
    <div class="progression-nav-card__background"></div>
    <div class="progression-nav-card__content">
      <div class="progression-nav-card__title">
        {{ title }}
      </div>
      <div class="progression-nav-card__summary">
        {{ summary }}
      </div>
    </div>
    <button
      class="progression-nav-card__cta"
      :class="{ 'd-none': disabled || ctaText == null }"
      @click="onCtaHandler">
      {{ ctaText }}
      <font-awesome-icon icon="chevron-right"
                         size="xs"></font-awesome-icon>
    </button>
  </div>
</template>
<script>
export default {
  name: "LmThreeSixtyInitial",
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    summary: {
      type: String,
      default: "",
    },
    ctaText: {
      type: String,
      default: "",
    },
  },
  methods: {
    onCtaHandler () {
      this.$emit( "cta-callback" );
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../Styles/utils/index.less";

.progression-nav-card {
  .border-radius(4px);
  border: 1px solid @blue;
  width: 300px;
  min-height: 180px;
  padding: 16px 20px 38px; /* accomodate cta in bottom padding */
  position: relative;

  &__disabled {
    .opacity();
  }

  &__background {
    .opacity-background(@light-blue, 0.7);
    border-radius: 4px;
  }

  &__content {
    margin: 0 0 32px 0;
    display: flex;
    flex-flow: column;
  }

  &__title {
    color: @blue;
    font-weight: 700;
    font-size: 18px;
    margin: 0 0 4px 0;
  }

  &__summary {
    color: @black;
    font-size: 16px;
    flex: 1;
  }

  &__cta {
    position: absolute;
    bottom: 12px;
    font-size: 16px;
    color: @dark-blue;
    .link();
    .color-hover(@blue);
  }
}
</style>
